import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IGeneralAssistantState {
  name: string;
  description: string;
}

const initialState: IGeneralAssistantState = {
  name: '',
  description: '',
};

const generalAssistantSlice = createSlice({
  name: 'generalAssistant',
  initialState,
  reducers: {
    setGeneralAssistant: (state, action: PayloadAction<{ name: string; description?: string }>) => {
      state.name = action.payload.name;
      state.description = action.payload.description ?? '';
    },
    setGeneralAssistantName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setGeneralAssistantDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    clearGeneralAssistant: () => initialState,
  },
});

export default generalAssistantSlice.reducer;

export const { setGeneralAssistant, setGeneralAssistantName, setGeneralAssistantDescription, clearGeneralAssistant } =
  generalAssistantSlice.actions;
